<template>
  <div class="card">
    <div class="card-body">
      <form class="form-sample" @submit.prevent="save()">
        <div class="row">
          <div class="col-md-6" v-for="(item, index) in fields_format" :key="index">
            <div class="form-group">
              <label>{{ item[alias_table + "_f_label"] }}</label>
              <small
                v-if="item[alias_table + '_f_validation'] !== '' && item[alias_table + '_f_validation'] !== null"
                class="pull-right text-danger ml-2"
              >*{{ item[alias_table + "_f_validation"] }}</small>
              <component
                :is="item[alias_table + '_f_input_type'] + '_form'"
                :name="item[alias_table + '_f_name']"
                :table_module="table_module"
                :validation="item[alias_table + '_f_validation']"
                :content="item['content']"
                :dropdown_name="item[alias_table + '_f_options']"
                :parsing-post-multi="post"
                :parsing-trigger="trigger_autocomplete"
                :select_all="( item[alias_table + '_f_name'] == 'crs_model_id' ? true : false )"
                @post="bindingData"
              ></component>
            </div>
          </div>

          <template v-if="table_module == 'services_bulk'">
            <div class="col-md-12">
              <div class="form-group">
                <label>Brand Mobil</label>
                <template>
                  <v-select
                    label="dd_o_label"
                    :reduce="optionsbrd => optionsbrd.dd_o_value"
                    :options="optionsbrd"
                    v-model="post_crs_bulk['crs_brand_id']"
                    @input="getCrsType()"
                  />
                </template>
              </div>
              <div class="form-group">
                <label>Type Mobil</label>
                <template>
                  <div>
                    <template>
                      <button type="button" :disabled="disabled" @click="selected_all" class="btn btn-sm btn-primary mr-2">Pilih Semua</button>
                      <button type="button" :disabled="disabled" @click="deselect_all" class="btn btn-sm btn-danger">Batal Pilih</button>
                    </template>
                    <v-select
                      multiple="multiple"
                      label="dd_o_label"
                      :reduce="optionsmdl => optionsmdl.dd_o_value"
                      :options="optionsmdl"
                      v-model="post_crs_bulk['crs_model_id']"
                      :disabled="post_crs_bulk['crs_brand_id'] == ''  || post_crs_bulk['crs_brand_id'] == null  ? true : false"
                      :close-on-select="false"
                    >
                    </v-select>
                  </div>
                </template>
              </div>
              <p>Daftar Produk</p>
              <hr>
              <table class="table table-centered table-striped table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Produk</th>
                    <th>Qty</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in post_crs_bulk.product" :key="'A'+index">
                    <td style="width : 70%">
                      <multiselect
                        v-model="post_crs_bulk['product'][index]"
                        :id="index"
                        label="dd_o_label"
                        track-by="dd_o_label"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="optionsproduct[index]"
                        :searchable="true"
                        :loading="isLoading"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="true"
                        group-values="value"
                        group-label="group"
                        @search-change="asyncFind"
                        @input="setTotalBiayaProduct()"
                        :disabled="post_crs_bulk['crs_brand_id'] == ''  || post_crs_bulk['crs_brand_id'] == null  ? true : false"
                      >
                        <template slot="option" slot-scope="props">
                          <span v-if="props.option.$isLabel">{{ props.option.$groupLabel }}</span>
                          <span v-else>
                            {{ props.option.dd_o_label }} <br>
                            <small>
                              Sku : {{ props.option.sku }} <br>
                              Harga : Rp. {{ $root.numberWithCommas(props.option.purchase) }}
                            </small>

                          </span>
                        </template>
                      </multiselect>
                    </td>
                    <td>
                      <input
                        type="number"
                        :name="'qty_'+index"
                        class="form-control"
                        v-model="post_crs_bulk['product'][index]['qty']"
                        required="required"
                        @input="setPurchase(index), setTotalBiayaProduct()"
                        :disabled="post_crs_bulk['crs_brand_id'] == ''  || post_crs_bulk['crs_brand_id'] == null  ? true : false"
                      />
                    </td>
                    <td>
                      <money
                        :name="'purchase_'+index"
                        class="form-control form-control-sm"
                        v-model="post_crs_bulk['product'][index]['price']"
                        v-bind="money"
                        required="required"
                        readonly
                      ></money>
                    </td>
                    <td>
                      <button
                        class="btn btn-icon btn-sm btn-danger"
                        type="button"
                        v-if="index != 0"
                        @click="deleteProduct(index)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="2">Total Biaya Product</th>
                    <th>
                      <money
                        :name="'biaya_service'"
                        class="form-control form-control-sm"
                        v-model="post_crs_bulk['total_biaya_product']"
                        v-bind="money"
                        required="required"
                        readonly
                      ></money>
                    </th>
                  </tr>
                </tfoot>
              </table>
              <button
                class="btn btn-info btn-icon btn-sm mb-2"
                type="button"
                @click="addProduct"
                :disabled="post_crs_bulk['crs_brand_id'] == ''  || post_crs_bulk['crs_brand_id'] == null  ? true : false"
              >
                <i class="fa fa-plus"></i> Tambah Produk
              </button>
              <hr>
              <p><b>Daftar Service</b></p>
              <hr>
              <table class="table table-centered table-striped table-bordered mb-0">
                <thead>
                  <tr>
                    <th>No. </th>
                    <th style="width: 70%;">Service</th>
                    <th >Harga</th>
                    <th class="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in post_crs_bulk.service" :key="'B'+index">
                    <td>{{ index+1 }}</td>
                    <td> 
                      <multiselect
                        v-model="post_crs_bulk['service'][index]"
                        :id="index"
                        label="dd_o_label"
                        track-by="dd_o_label"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="optionservices[index]"
                        :searchable="true"
                        :loading="isLoading"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="true"
                        group-values="value"
                        group-label="group"
                        @search-change="asyncFindService"
                        @input="setTotalBiayaService()"
                        :disabled="post_crs_bulk['crs_brand_id'] == ''  || post_crs_bulk['crs_brand_id'] == null  ? true : false"
                      >
                        <template slot="option" slot-scope="props">
                          <span v-if="props.option.$isLabel">{{ props.option.$groupLabel }}</span>
                          <span v-else>
                            {{ props.option.dd_o_label }} <br>
                            <small>
                              Harga : Rp. {{ $root.numberWithCommas(props.option.price) }}
                            </small>
                          </span>
                        </template>
                      </multiselect>
                    </td>
                    <td>
                      <money
                        :name="'price_'+index"
                        class="form-control form-control-sm"
                        v-model="post_crs_bulk['service'][index]['price']"
                        v-bind="money"
                        required="required"
                        readonly
                      ></money>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-icon btn-sm btn-danger"
                        type="button"
                        v-if="index != 0"
                        @click="deleteService(index)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="2">Total Biaya Service</th>
                    <th>
                      <money
                        :name="'biaya_service'"
                        class="form-control form-control-sm"
                        v-model="post_crs_bulk['total_biaya_service']"
                        v-bind="money"
                        required="required"
                        readonly="readonly"
                      ></money>
                    </th>
                  </tr>
                </tfoot>
              </table>
              <button
                class="btn btn-info btn-icon btn-sm mb-2"
                type="button"
                @click="addService"
              >
                <i class="fa fa-plus"></i> Tambah Service
              </button>

              <div class="form-group">
                <label for="">Total Biaya</label>
                <money
                  :name="'harga'"
                  class="form-control form-control-sm"
                  v-model="post_crs_bulk['total_harga']"
                  v-bind="money"
                  required="required"
                  readonly
                ></money>
              </div>
              <div class="form-group">
                <label for="">Diskon</label>
                <money
                  :name="'harga'"
                  class="form-control form-control-sm"
                  v-model="post_crs_bulk['discount']"
                  v-bind="money"
                  required="required"
                  @input="setHargaPaket"
                ></money>
              </div>
              <div class="form-group">
                <label for="">Harga Paket</label>
                <money
                  :name="'harga'"
                  class="form-control form-control-sm"
                  v-model="post_crs_bulk['harga_paket']"
                  v-bind="money"
                  required="required"
                ></money>
              </div>
            </div>
          </template>

          <template v-if="table_module == 'services'">
           
            <div class="col-md-12">
              <hr />
              <p>Pilih Mobil</p>
              <table class="table table-centered table-striped table-bordered mb-0">
                <thead>
                  <tr>
                    <td :width="(item_fields_add_cars[alias_table+'_f_name'] == 'crs_brand_id' ? '20%' : '30%')" v-for="(item_fields_add_cars, index_fields_add_cars) in fields_add_cars" :key="index_fields_add_cars+'_index_fields_add_cars'">
                      {{ item_fields_add_cars[alias_table+'_f_label'] }}
                    </td>
                    <td width="5%"></td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in post_crs" :key="index">
                    <td v-for="(item_fields_add_cars, index_fields_add_cars) in fields_add_cars" :key="index_fields_add_cars+'_index_fields_add_cars'">
                      <component
                        :is="item_fields_add_cars[alias_table + '_f_input_type'] + '_form'"
                        :name="item_fields_add_cars[alias_table + '_f_name']"
                        :table_module="table_module"
                        :validation="item_fields_add_cars[alias_table + '_f_validation']"
                        :content="item[item_fields_add_cars[alias_table + '_f_name']]"
                        :dropdown_name="item_fields_add_cars[alias_table + '_f_options']"
                        :parsing-post-multi="post_crs[index]"
                        :parsing-trigger="trigger_autocomplete_cars[index]"
                        :disable_option="post_crs"
                        @post="bindingDataCars($event, index)"
                        :select_all="(item_fields_add_cars[alias_table + '_f_name'] == 'crs_model_id' ? true : false)"
                      ></component>
                    </td>                  
                    <td>
                      <button
                        class="btn btn-icon"
                        type="button"
                        v-if="index != 0"
                        @click="deleteCars(index)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                      <button
                        class="btn btn-info btn-icon"
                        type="button"
                        v-else
                        @click="addCars"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template v-if="table_module == 'services'">
            <div class="col-md-12">
              <hr />
              <p>External Price</p>
              <table class="table table-centered table-striped table-bordered table-nowrap mb-0">
                <thead>
                  <tr>
                    <td width="40%">Supplier</td>
                    <td width="20%">Price</td>
                    <td width="30%">Description</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in post_supplier" :key="index">
                    <td>
                      <v-select
                        label="spr_name"
                        :options="data_supplier['data']"
                        :filterable="false"
                        inputId="spr_id"
                        :value="item.spr_name"
                        @search="searchAutocompleteSupplier"
                        @input="(spr_name) => updatesupplier(index, spr_name)"
                      ></v-select>
                    </td>
                    <td>
                      <currency-input
                        name="srv_price_external"
                        class="form-control form-control-sm"
                        v-model="item.srv_price_external"
                        v-bind="money"
                      ></currency-input>
                    </td>
                    <td>
                      <textarea
                        class="form-control form-control-sm"
                        name="srv_description_external"
                        cols="10"
                        rows="2"
                        v-model="item.srv_description_external"
                      ></textarea>
                    </td>
                    <td>
                      <button
                        class="btn btn-icon"
                        type="button"
                        v-if="index != 0"
                        @click="deleteSupplier(index)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                      <button
                        class="btn btn-info btn-icon"
                        type="button"
                        v-else
                        @click="addSupplier"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
    
        <template v-if="fields_editor.length > 0">
          <hr>
          <div class="row">
            <div class="col-md-12 mb-3" v-for="(item_fields_editor, index_fields_editor) in fields_editor" :key="index_fields_editor+'_fields_editor'">
              <label>{{ item_fields_editor[alias_table + "_f_label"] }}</label>
              <small
                v-if="item_fields_editor[alias_table + '_f_validation'] != ''"
                class="pull-right text-danger"
              >*{{ item_fields_editor[alias_table + "_f_validation"] }}</small>
              <component
                :is="item_fields_editor[alias_table + '_f_input_type'] + '_form'"
                :name="item_fields_editor[alias_table + '_f_name']"
                :table_module="table_module"
                :validation="item_fields_editor[alias_table + '_f_validation']"
                :content="item_fields_editor['content']"
                :dropdown_name="item_fields_editor[alias_table + '_f_options']"
                :parsing-post-multi="post"
                :parsing-trigger="trigger_autocomplete"
                @post="bindingData"
              ></component>
            </div>
          </div>
        </template>
        <hr />

        <div class="justify-content-end d-flex">
          <router-link class="btn btn-secondary btn-sm mr-2" :to="{ name: table_module }">Cancel</router-link>
          <!-- <button
            type="submit"
            class="btn btn-primary btn-sm"
          >{{ uuid == null ? "Save" : "Update" }}</button> -->
          <b-button
            type="submit"    
            variant="primary"
            class="btn btn-primary btn-sm"
            :disabled="disabled"
          >
            <template v-if="disabled">
              <b-spinner small type="grow"></b-spinner>
              Loading ..
            </template>
            <template v-else>
              {{ uuid == null ? "Save" : "Update" }}
            </template>
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import text_form from "@/components/input/text";
import longtext_form from "@/components/input/longtext";
import number_form from "@/components/input/number";
import option_form from "@/components/input/option";
import m_option_form from "@/components/input/m_option";
import s_autocomplete_form from "@/components/input/single_autocomplete";
import m_autocomplete_form from "@/components/input/multiple_autocomplete";
import phone_form from "@/components/input/phone";
import time_form from "@/components/input/time";
import datetime_form from "@/components/input/datetime";
import money_form from "@/components/input/money";
import year_form from "@/components/input/year";
import radio_form from "@/components/input/radio";
import s_image_form from "@/components/input/s_image";
import m_image_form from "@/components/input/m_image";
import email_form from "@/components/input/email";
import editor_form from "@/components/input/editor";
import tag_form from "@/components/input/tags";
import date_form from "@/components/input/date";
import multiplegroup_autocomplete_form from "@/components/input/multiplegroup_autocomplete";

import { Money } from "v-money";
import { _ } from "vue-underscore";
import VueClockPicker from "@pencilpix/vue2-clock-picker";
import "@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css";

export default {
  props: {
    fields: {
      type: [Object, Array],
      required: true,
    },
    table_module: {
      type: String,
      required: true,
    },
    module: {
      type: String,
      required: true,
    },
    alias_table: {
      type: String,
      required: true,
    },
    data_extra : {
      type : Object
    },
    post_supplier: {
      type: Array,
      default: function () {
        return [
          {
            srv_r_spr_id: "",
            spr_id: "",
            srv_price_external: 0,
            srv_description_external: "",
          },
        ];
      },
    },
    post_services: {
      type: Array,
      default: function () {
        return [
          {
            srv_id: "",
            srv_code: "",
            srv_price: "",
            srv_time: "",
            srv_name: "",
          },
        ];
      },
    },
    post_crs_bulk: {
      type: Object,
      default: function () {
        return {
          crs_brand_id : null,
          crs_model_id : [],
          product : [
            {
              dd_o_label : "",
              dd_o_value : "",
              qty : 1,
              purchase : 0,
              price : 0
            }
          ],
          service :  [
              {
                dd_o_label : "",
                dd_o_value : "",
                price : 0
              }
            ],
          total_biaya_service : 0,
          total_biaya_product : 0,
          harga_paket : 0,
          discount : 0,
          total_harga : 0,
        }
      }
    },
    post_crs: {
      type: Array,
      default: function () {
        return[ {
          crs_brand_id : null,
          crs_model_id : [],
        }]
      }
    },
  },
  data() {
    return {
      post: {},
      trigger_autocomplete: "",
      money: {
        thousands: ".",
        prefix: "Rp ",
        precision: 0,
      },
      data_supplier: [],
      data_services: [],
      dataCarsBrands: [],
      trigger_autocomplete_cars: [],
      disabled : false,
      optionsbrd : [],
      optionsmdl : [],
      isLoading: false,
      optionsproduct: [],
      optionservices: [],
    };
  },
  components: {
    text_form,
    longtext_form,
    number_form,
    option_form,
    s_autocomplete_form,
    phone_form,
    time_form,
    datetime_form,
    money_form,
    m_autocomplete_form,
    year_form,
    radio_form,
    s_image_form,
    email_form,
    editor_form,
    tag_form,
    m_image_form,
    Money,
    VueClockPicker,
    date_form,
    m_option_form,
    multiplegroup_autocomplete_form
  },
  mounted() {
    if (this.table_module == "store") {
      this.getBrands();
    }else if (this.table_module == "services_bulk" && this.uuid != null){
        if (this.data_extra && this.data_extra.srv_b_price != null) {
          this.$set(this.post, 'srv_b_price', this.data_extra.srv_b_price);
        }
    }

    if(this.table_module == 'services_bulk'){
      this.getCrsBrd()
      this.getCrsType()
      this.optionsproduct = this.post_crs_bulk.product.map(() => [])
      this.optionservices = this.post_crs_bulk.service.map(() => [])
    }
  },

  watch: {
    fields(newFields) {
      if (this.uuid && Array.isArray(newFields) && newFields.length > 0 && this.table_module == 'services_bulk') {
        const skipFields = ['crs_model_id', 'crs_brand_id', 'prd_id'];
        newFields.forEach(field => {
          const fieldName = field[this.alias_table + '_f_name'];
          if (skipFields.includes(fieldName)) return;
          if (field.content !== '' && field.content !== null && field.content !== undefined) {
            this.$set(this.post, fieldName, field.content);
          }
        });
      }
    },
    'post_crs_bulk.crs_brand_id'(newVal) {
      if (this.table_module == 'services_bulk') {
        this.getCrsType();
        if (!newVal) {
          this.optionsmdl = [];
        }
      }
    },
    'post_crs_bulk.product'(newVal) {
      if (this.table_module == 'services_bulk') {
        while (this.optionsproduct.length < newVal.length) {
          this.optionsproduct.push([]);
        }
      }
    },
    'post_crs_bulk.service'(newVal) {
      if (this.table_module == 'services_bulk') {
        while (this.optionservices.length < newVal.length) {
          this.optionservices.push([]);
        }
      }
    },
  },

  computed: {
    uuid() {
      return this.$route.params.uuid;
    },
    getTime() {
      var h = "00:00";
      

      return h;
    },
    fields_format(){
      if (this.fields.length > 0) {
        if (this.table_module == 'services' || this.table_module == 'services_bulk') {
          return this.fields.filter(
            (x) =>
              x[this.alias_table + "_f_input_type"] != "editor" &&
              x[this.alias_table + "_f_name"] != "crs_brand_id" &&
              x[this.alias_table + "_f_name"] != "crs_model_id" &&
              x[this.alias_table + "_f_name"] != "prd_id" 
          );
        }
        else {
          return this.fields.filter(
            (x) =>
              x[this.alias_table + "_f_input_type"] != "editor"
          );
        }
      }

      return [];
    },
    fields_editor() {
      if (this.fields.length > 0) {
        return this.fields.filter(
          (x) =>
            x[this.alias_table + "_f_input_type"] == "editor"
        );     
      }
      return [];
    },
    fields_add_cars(){
      if (this.fields.length > 0) {
        return this.fields.filter(
          (x) =>
            x[this.alias_table + "_f_name"] == "crs_brand_id" ||
            x[this.alias_table + "_f_name"] == "crs_model_id" ||
            x[this.alias_table + "_f_name"] == "prd_id"
        );     
      }
      return [];
    },
  },
  methods: {
    deleteCars(index) {
      this.$delete(this.post_crs, index);
    },
    addCars() {
      this.post_crs.push({
        crs_brand_id: null,
        crs_model_id: [],
      });
    },
    deleteSupplier(index) {
      this.$delete(this.post_supplier, index);
    },
    addSupplier() {
      this.post_supplier.push({
        srv_r_spr_id: "",
        spr_id: "",
        srv_price_external: 0,
        srv_description_external: "",
      });
    },
    deleteServices(index) {
      this.$delete(this.post_services, index);
      this.getPrice();
    },
    addServices() {
      this.post_services.push({
        srv_id: "",
        srv_code: "",
        srv_price: "",
        srv_time: "",
        srv_name: "",
      });
    },
    classCol(arm = "") {
      var res = "col-md-6";
      if (arm == "longtext") {
        res = "col-md-12";
      }
      return res;
    },
    save: function () {
      this.disabled = true;
      const uuid = this.$route.params.uuid;
      if (this.table_module == "services") {
        var spr_id = [];

        for (const key in this.post_supplier) {
          if (
            this.post_supplier[key].spr_id != "" &&
            this.post_supplier[key].spr_id != null
          ) {
            var bindSpr = {
              srv_r_spr_id: this.post_supplier[key].srv_r_spr_id,
              srv_id: this.post_supplier[key].srv_id,
              spr_id: this.post_supplier[key].spr_id,
              srv_price_external: this.post_supplier[key].srv_price_external,
              srv_description_external: this.post_supplier[key]
                .srv_description_external,
            };

            spr_id.push(bindSpr);
          }
        }

        this.$set(this.post, "post_spr", spr_id);
        this.$set(this.post, "post_crs", this.post_crs);
      } else if (this.table_module == "services_bulk") {
        this.$delete(this.post, "crs_brand_id");
        this.$set(this.post, "post_crs", this.post_crs_bulk);
      }

      if (uuid == null) {
        this.axios
          .post("/" + this.table_module + "/save", this.post)
          .then((response) => {
            if (response.data.status == 200) {
              this.$toast("Simpan data berhasil");
              this.$router.push({ name: this.table_module });
            }
            this.disabled = false;
          });
      } else {
        this.axios
          .post("/" + this.table_module + "/update/" + uuid, this.post)
          .then((response) => {
            if (response.data.status == 200) {
              this.$toast("Update data berhasil");
              this.$router.push({ name: this.table_module, query : this.$route.query });
            }
            this.disabled = false;
          });
      }
    },
    bindingData: function (value) {
      if (value["value"] == null || value["value"] === "") {
        if (this.table_module == "services_bulk" && value["name"] == "srv_id") {
          this.$children.forEach((element, key) => {
            if (element.name == "srv_id") {
              this.$children[key].post = [];
              this.$children[key].extra = {};
              this.$children[key].list = {};
            }
          });
        }
        this.$delete(this.post, value["name"]);
      } else {
        if (value.name == "prd_image") {
          if (this.post[value.name] == undefined) {
            var arr = [];
            arr.push(value["value"]);
            this.$set(this.post, value["name"], arr);
          } else {
            this.post[value.name].push(value["value"]);
          }
        } else if (this.table_module == "services_bulk") {
          if (value.name == "crs_brand_id") {
            this.trigger_autocomplete =
              Math.floor(100000 + Math.random() * 900000) + "_crs_model_id";
            this.$delete(this.post, "crs_model_id");
            this.$emit("clearDefaultServices");
            this.data_services = [];
          }

          this.$set(this.post, value["name"], value["value"]);
        } else {
          if (this.table_module == "services") {
            if (value.name == "crs_brand_id") {
              this.trigger_autocomplete =
                Math.floor(100000 + Math.random() * 900000) + "_crs_model_id";
              this.$delete(this.post, "crs_model_id");
              this.$emit("clearDefaultServices");
              this.data_supplier = [];
            }
          }
          this.$set(this.post, value["name"], value["value"]);
        }
      }
    },
    bindingDataCars: function(value, index){
      if (value.name == "crs_model_id") 
      {
        this.$set(this.post_crs[index], value["name"], value["value"]);
      }

      if (value.value != '' && value.value != null) {
        this.$set(this.post_crs[index], value["name"], value["value"]);
        if (value.name == "crs_brand_id") {
          this.$set(this.trigger_autocomplete_cars, index, this.$moment() + Math.random().toString(36).slice(2))
        }        
      }
      console.log(this.post_crs)
    },
    searchAutocompleteSupplier(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.searchDeb(loading, search, this, "supplier");
      }
    },
    searchAutocompleteServices(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.searchDeb(loading, search, this, "services");
      }
    },
    searchDeb: _.debounce((loading, search, vm, table_module = "") => {
      var params = {};
      var uri = "";

      if (table_module == "supplier") {
        uri = "spr_id";
        params = {
          ["search[spr_name]"]: search,
        };
      } else if (table_module == "services") {
        uri = "srv_id";
        params = {
          ["search[srv_name]"]: search,
        };

        if (vm.table_module == "services_bulk") {
          if (typeof vm.post.crs_model_id !== undefined) {
            params["filter[crs_model_id]"] = vm.post.crs_model_id;
          }
        }
      }

      vm.axios
        .get("/dropdown/autocomplete/" + uri, { params: params })
        .then((response) => {
          loading(false);
          if (table_module == "supplier") {
            vm.data_supplier = response.data.data;
          } else if (table_module == "services") {
            vm.data_services = response.data.data;
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
    updatesupplier(index, spr_name) {
      this.$set(this.post_supplier[index], "spr_id", spr_name.spr_id);
    },
    updateservices(index, item) {
      var res = {
        srv_id: item.srv_id,
        srv_name: item.srv_name,
        srv_code: item.srv_code,
        srv_time: item.srv_time,
        srv_act_price: item.srv_price,
        srv_est_price: item.srv_price,
        spr_id: item.spr_id,
      };

      this.$set(this.post_services, index, res);

      this.getPrice();
    },
    getBrands() {
      var params = {
        page: 1,
        show: 100,
      };

      this.axios.get("/cars_brand", { params: params }).then((response) => {
        this.dataCarsBrands = response.data.data["cars_brand"];
        this.isLoading = false;
      });
    },
    bindSpr(index, key, data) {
      console.log(key);
      if (key !== null && data != undefined && key !== "" && key != undefined) {
        console.log(data[key]);
        this.$set(this.post_services[index], "spr_id_true", data[key].spr_id);
        this.$set(this.post_services[index], "spr_name", data[key].spr_name);
        this.$set(
          this.post_services[index],
          "srv_est_price_external",
          data[key].srv_price_external
        );
        this.$set(
          this.post_services[index],
          "srv_act_price_external",
          data[key].srv_price_external
        );
      }
    },
    update_value_price(evt) {
      console.log(evt);
      console.log(this.post_services[evt].srv_act_price);
      // var total_price_services = evt + this.post.srv_b_price
      // this.$set(this.post, 'srv_b_price', total_price_services);
    },
    getPrice() {
      var res = 0;
      for (const key in this.post_services) {
        if (this.post_services[key].srv_act_price !== null) {
          res += this.post_services[key].srv_act_price;
        }
      }
      console.log('jalan');

      this.$set(this.post, "srv_b_price", res);

      var listTime = [];
      for (const key in this.post_services) {
        if (this.post_services[key].srv_time !== "") {
          // res += this.post_services[key].srv_time;
          listTime.push(this.post_services[key].srv_time);
        } else {
          var x = "00:00";
          listTime.push(x);
        }
      }

      const totalDurations = listTime
        .slice(1)
        .reduce(
          (prev, cur) => this.$moment.duration(cur).add(prev),
          this.$moment.duration(listTime[0])
        );

      this.$set(
        this.post,
        "srv_b_time",
        this.$moment.utc(totalDurations.asMilliseconds()).format("HH:mm")
      );
    },
    getCrsBrd(){
      this.axios
      .get("/dropdown/list/dd_crs_brands")
      .then((response) => {
        let data = response.data.data;
        this.optionsbrd = data
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 500) {
            console.log("error 500");
          }
        }
      });
    },
    getCrsType(){
      if( this.post_crs_bulk['crs_brand_id'] != "" && this.post_crs_bulk['crs_brand_id'] != null ){
        var params = {
         "filter[crs_brand_id]" : this.post_crs_bulk['crs_brand_id']
        };
        this.axios
          .get("/dropdown/list/dd_crs_model", { params: params })
          .then((response) => {
            this.optionsmdl = response.data.data;
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 500) {
                console.log("error 500");
              }
            }
          });  
      }
    },
    selected_all(){
      if (this.optionsmdl.length > 0) 
      {
        this.optionsmdl.forEach((element, key) => {
          this.$set( this.post_crs_bulk['crs_model_id'], key, element.dd_o_value)
          // console.log(key, element.dd_o_value);
        }); 
      }
    },
    deselect_all(){
      this.post_crs_bulk['crs_model_id'] = [];
    },
    limitText(count) {
      return ` ${count} item lainya`;
    },
    asyncFind: _.throttle(function (query, id) {
      console.log(id)
      if (query.length == 0) {
        return false;
      }

      this.isLoading = true;
      var params = {};

        params = {
          ["search[prd_name]"]: query,
        };

        params["input_type"] = "multiplegroup_autocomplete";
        if (typeof this.post_crs_bulk.crs_model_id !== "undefined") {
          params["filter[crs_model_id]"] = this.post_crs_bulk.crs_model_id;
        }

      this.axios
        .get("/dropdown/autocomplete/dd_prd_id", { params: params })
        .then((response) => {
          this.isLoading = false;
          this.$set(this.optionsproduct, id, response.data.data);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
    asyncFindService:_.throttle(function (query, id) {
      if (query.length == 0) {
        return false;
      }

      this.isLoading = true;
      var params = {};

        params = {
          ["search[srv_name]"]: query,
        };

        if (typeof this.post_crs_bulk.crs_model_id !== "undefined") {
          params["filter[crs_model_id]"] = this.post_crs_bulk.crs_model_id;
        }

      this.axios
        .get("/dropdown/autocomplete/dd_srv_id", { params: params })
        .then((response) => {
          this.isLoading = false;
          this.$set(this.optionservices, id, response.data.data);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
    addProduct() {
      this.post_crs_bulk.product.push({
        dd_o_label : "",
        dd_o_value : "",
        qty : 1,
        purchase : 0,
        price : 0
      });
      this.optionsproduct.push([]);
    },
    deleteProduct(index) {
      this.$delete(this.post_crs_bulk.product, index);
      this.$delete(this.optionsproduct, index);
      this.setTotalBiayaProduct()
    },
    addService() {
      this.post_crs_bulk.service.push({
        dd_o_label : "",
        dd_o_value : "",
        price : 0
      });
      this.optionservices.push([]);
    },
    deleteService(index) {
      this.$delete(this.post_crs_bulk.service, index);
      this.$delete(this.optionservices, index);
      this.setTotalBiayaService()
    },
    setQty(selectedOption, id){
      var value = selectedOption;
      selectedOption['qty'] = 1
      selectedOption['price'] = value.purchase
      this.post_crs_bulk.product[id] = value
    },
    setPurchase(index){
       this.post_crs_bulk.product[index].price =  this.post_crs_bulk.product[index].purchase *  this.post_crs_bulk.product[index].qty
    },
    setTotalBiayaProduct(){
      this.post_crs_bulk.total_biaya_product = 0
      this.post_crs_bulk.product.forEach(element => {
        this.post_crs_bulk.total_biaya_product += element.price
      });

      this.setTotalBiaya()
    },
    setTotalBiayaService(){
      this.post_crs_bulk.total_biaya_service = 0
      this.post_crs_bulk.service.forEach(element => {
        this.post_crs_bulk.total_biaya_service += element.price
      });

      this.setTotalBiaya()
    },
    setTotalBiaya(){
      this.post_crs_bulk.total_harga = this.post_crs_bulk.total_biaya_product + this.post_crs_bulk.total_biaya_service 
    },
    setHargaPaket(){
      if(this.post_crs_bulk.total_harga != 0 && this.post_crs_bulk.discount != 0){
        this.post_crs_bulk.harga_paket = this.post_crs_bulk.total_harga - this.post_crs_bulk.discount 
      }
    }
  },
};
</script>
